import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getOAuthToken, getOAuthTokenGoogle } from '@/services/userService';

export const useLogin = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [success, setSuccess] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [loginType, setLoginType] = useState(null);
  const [googleError, setGoogleError] = useState(null);
  const languageData = useSelector(state => state.lenguage?.lang);
  const navigate = useNavigate();

  const handleSubmit = async values => {
    setLoading(true);
    setError(null);
    setSuccess(false);
    setSuccessMessage(null);

    try {
      const result = await getOAuthToken({
        username: values.email,
        password: values.password,
      });

      console.log('OAuth result:', result);

      if (result?.access_token) {
        localStorage.setItem('access_token', result.access_token);
        localStorage.setItem('refresh_token', result.refresh_token);

        setSuccess(true);
        setSuccessMessage('Login successful');
        setLoginType('login');
        setShowModal(true);

        return result;
      } else {
        throw new Error('Invalid credentials');
      }
    } catch (err) {
      console.error('Login error:', err);

      setError('Invalid credentials. Please try again.');
      setSuccess(false);

      setTimeout(() => {
        setError(null);
      }, 3000);

      return null;
    } finally {
      setLoading(false);
    }
  };

  const loginWithGoogleOAuth = async ({ username, googleToken }) => {
    setLoading(true);
    setGoogleError(null);
    setError(null);

    try {
      const tokenData = await getOAuthTokenGoogle({
        username,
        googleToken,
      });

      setLoginType('google');
      setShowModal(true);

      return tokenData;
    } catch (err) {
      const apiError =
        err?.response?.data?.error ||
        err?.response?.data?.code ||
        err?.response?.data?.message ||
        err?.message ||
        '';

      if (String(apiError).toLowerCase().includes('bad')) {
        setGoogleError(
          languageData === 'EN'
            ? 'The user has already been registered previously with this email'
            : 'El usuario ya fue registrado previamente con este email',
        );
      } else {
        setGoogleError(
          languageData === 'EN'
            ? 'Could not sign in with Google'
            : 'No se pudo iniciar sesión con Google',
        );
      }

      throw err;
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const goHome = () => {
    setShowModal(false);
    navigate('/');
  };

  const goBack = () => {
    setShowModal(false);
    navigate(-1);
  };

  return {
    loading,
    error,
    success,
    successMessage,
    handleSubmit,
    googleError,
    loginWithGoogleOAuth,
    showModal,
    loginType,
    closeModal,
    goHome,
    goBack,
  };
};
